import { render, staticRenderFns } from "./wordCloud3D.vue?vue&type=template&id=56bfe824&scoped=true"
import script from "./wordCloud3D.vue?vue&type=script&lang=js"
export * from "./wordCloud3D.vue?vue&type=script&lang=js"
import style0 from "./wordCloud3D.vue?vue&type=style&index=0&id=56bfe824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bfe824",
  null
  
)

export default component.exports